var indexOf = [].indexOf;

angular.module('website').directive('websiteWeeklyAgenda', function() {
  return {
    restrict: 'E',
    scope: {
      showCalendar: '&',
      isIframe: '=',
      isFreeTrials: '=',
      hideNavigation: '='
    },
    template: require('templates/website/calendar/website_weekly_agenda.html.slim'),
    controller: ["$scope", "$state", "$stateParams", "$window", "$modal", "$location", "$filter", "$q", "$document", "$timeout", "DataService", "CalendarService", "Restangular", "ContrastColor", function($scope, $state, $stateParams, $window, $modal, $location, $filter, $q, $document, $timeout, DataService, CalendarService, Restangular, ContrastColor) { // fixes empty $stateParams
      var CalendarData, Classrooms, Website, domain, getEvents, groupEvents, parseIds, promises;
      moment.updateLocale('en', {
        week: {
          dow: DataService.calendar_start_wday
        }
      });
      domain = DataService.domain;
      $scope.glossary = DataService.glossary;
      $scope.date = moment();
      $scope.filtersMultiSelect = DataService.gym_config.website_calendar_filters === 'multi_select';
      $scope.showInstructor = DataService.gym_config.show_instructor_on_website_calendar;
      $scope.showCapacity = DataService.gym_config.show_capacity_on_website_calendar;
      $scope.bookingSuccessGtmId = DataService.gym_config.gtm_code_for_website_booking_success;
      $scope.freeTrialBookingSuccessful = false;
      $scope.pixelId = DataService.gym_config.facebook_pixel_id_for_free_trial_calendar;
      $scope.pixelEvent = DataService.gym_config.facebook_pixel_event_for_free_trial_calendar;
      Website = Restangular.all('websites').all(domain);
      Classrooms = Website.all('classrooms');
      CalendarData = Website.all('calendar').all('data');
      parseIds = function(val) {
        if (!val) {
          return [];
        }
        if (Array.isArray(val)) {
          return val.map(function(item) {
            return +item;
          });
        } else {
          return [+val];
        }
      };
      $scope.locations = [];
      $scope.instructors = DataService.instructors;
      $scope.eventTypes = DataService.event_types;
      $scope.selectedInstructors = [];
      $scope.selectedInstructors = $scope.instructors.filter(function(type) {
        var id, ids;
        id = type.id.toString();
        ids = $stateParams['instructor_id[]'];
        return id === $stateParams.instructor_id || (ids && indexOf.call(ids, id) >= 0);
      });
      $scope.selectedEventTypes = $scope.eventTypes.filter(function(type) {
        var id, ids;
        id = type.id.toString();
        ids = $stateParams['event_type_id[]'];
        return id === $stateParams.event_type_id || (ids && indexOf.call(ids, id) >= 0);
      });
      getEvents = function() {
        var end, params, ref, start;
        start = $scope.date.clone().startOf('week');
        end = $scope.date.clone().endOf('week');
        params = {
          start: start.format('X'),
          end: end.format('X'),
          'location_id[]': $scope.selectedLocations.map(function(item) {
            return item.id;
          }),
          'instructor_id[]': $scope.selectedInstructors.map(function(item) {
            return item.id;
          }),
          'event_type_id[]': $scope.selectedEventTypes.map(function(item) {
            return item.id;
          }),
          prospect_spaces_available: $scope.isFreeTrials && 1
        };
        $scope.displayOldEventsHiddenWarning = ((ref = window.DATA) != null ? ref.old_event_display_threshold : void 0) > start.format('X');
        $scope.oldEventDisplayThresholdDate = moment(new Date(window.DATA.old_event_display_threshold * 1000)).format('LL');
        $scope.title = `${start.format('MMM D, YYYY')} - ${end.format('MMM D, YYYY')}`;
        return CalendarData.getList(params).then(function(events) {
          $scope.eventsByDay = groupEvents(events.plain());
          return $scope.eventsCount = events.length;
        });
      };
      promises = [Classrooms.getList(), CalendarService.getEvent($stateParams.event_id)];
      $q.all(promises).then(function(result) {
        var defaultLocationIds, event, locations, ref, ref1, ref2, ref3, ref4;
        $scope.locations = locations = result[0];
        event = result[1];
        defaultLocationIds = ((ref = parseIds($stateParams.location_id)) != null ? ref.length : void 0) ? parseIds($stateParams.location_id) : ((ref1 = parseIds($stateParams['location_id[]'])) != null ? ref1.length : void 0) ? parseIds($stateParams['location_id[]']) : DataService.gym_config.default_calendar_location_id ? [DataService.gym_config.default_calendar_location_id] : [];
        $scope.selectedLocations = _.filter(locations, function(location) {
          var ref2;
          return ref2 = location.id, indexOf.call(defaultLocationIds, ref2) >= 0;
        });
        if ((ref2 = parseIds($stateParams.ex_location_id)) != null ? ref2.length : void 0) {
          $scope.selectedLocations = _.filter(locations, function(location) {
            var ref3;
            return ref3 = location.id, indexOf.call(parseIds($stateParams.ex_location_id), ref3) < 0;
          });
        } else if ((ref3 = parseIds($stateParams['ex_location_id[]'])) != null ? ref3.length : void 0) {
          $scope.selectedLocations = _.filter(locations, function(location) {
            var ref4;
            return ref4 = location.id, indexOf.call(parseIds($stateParams['ex_location_id[]']), ref4) < 0;
          });
        }
        if ((defaultLocationIds != null ? defaultLocationIds.length : void 0) && !((ref4 = $scope.selectedLocations) != null ? ref4.length : void 0)) {
          $scope.selectedLocations = [locations[0]];
        }
        if (event) {
          $scope.date = moment(event.start, 'YYYY/MM/DD HH:mm');
          $scope.onEventSelect(event);
        }
        return getEvents();
      });
      $scope.goToCalendar = function() {
        var url;
        if ($scope.isIframe) {
          return $scope.showCalendar();
        } else {
          url = `/websites/${domain}/calendar`;
          $window.open(url, '_self');
          return true;
        }
      };
      $scope.switchDay = function(value) {
        $scope.date = $scope.date.add(value, 'weeks');
        return getEvents();
      };
      $scope.today = function() {
        $scope.date = moment();
        return getEvents();
      };
      $scope.isToday = function() {
        return moment().format('L') === $scope.date.format('L');
      };
      $scope.onBookingSuccess = function(eventParams) {
        $scope.bookingComplete = true;
        return $timeout(function() {
          if (!window.dataLayer) {
            return;
          }
          return window.dataLayer.push(eventParams);
        }, 500);
      };
      $scope.onEventSelect = function(event) {
        var bookingModal;
        $scope.bookingComplete = false;
        $document.scrollTop(0);
        if (event.cancelled) {
          bookingModal = $modal.open({
            template: require('templates/cancelled_event_modal.html'),
            controller: 'BookingModalCtrl',
            resolve: {
              event: function() {
                var selectedEvent;
                selectedEvent = angular.extend({}, event);
                selectedEvent.start = moment(selectedEvent.start, 'YYYY/MM/DD HH:mm').toDate();
                return selectedEvent;
              },
              isFreeTrials: function() {
                return $scope.isFreeTrials;
              },
              onBookingSuccess: function() {
                return $scope.onBookingSuccess;
              }
            }
          });
        } else {
          bookingModal = $modal.open({
            template: require('templates/create_booking_modal.html'),
            controller: 'BookingModalCtrl',
            resolve: {
              event: function() {
                var selectedEvent;
                selectedEvent = angular.extend({}, event);
                selectedEvent.start = moment(selectedEvent.start, 'YYYY/MM/DD HH:mm').toDate();
                return selectedEvent;
              },
              isFreeTrials: function() {
                return $scope.isFreeTrials;
              },
              onBookingSuccess: function() {
                return $scope.onBookingSuccess;
              }
            }
          });
        }
        return bookingModal.result.then(function() {
          if (event.free_class) {
            $scope.freeTrialBookingSuccessful = true;
          }
          return getEvents();
        });
      };
      groupEvents = function(events) {
        return _.chain(events).map(function(event) {
          var ref;
          event.date = moment(event.start, 'YYYY/MM/DD HH:mm').startOf('day').format('X');
          event.isCancelled = !!event.cancelled;
          event.isTitleLong = ((ref = event.title) != null ? ref.length : void 0) > 20;
          return event;
        }).groupBy('date').value();
      };
      $scope.isFiltersAvailable = function() {
        return $scope.locations.length > 1 || $scope.instructors.length > 1 || $stateParams.event_type_id || $stateParams['event_type_id[]'];
      };
      $scope.onLocationsChange = function(selectedLocations) {
        $location.search('location_id', selectedLocations.map(function(item) {
          return item.id;
        }));
        $location.search('ex_location_id', []);
        $location.search('ex_location_id[]', []);
        $scope.selectedLocations = selectedLocations;
        return getEvents();
      };
      $scope.onInstructorsChange = function(selectedInstructors) {
        $scope.selectedInstructors = selectedInstructors;
        return getEvents();
      };
      $scope.onEventTypesChange = function(selectedEventTypes) {
        $scope.selectedEventTypes = selectedEventTypes;
        $location.search('event_type_id', selectedEventTypes.map(function(item) {
          return item.id;
        }));
        return getEvents();
      };
      $scope.placesLeft = function(event) {
        var ref;
        if ((ref = event.participant_limit) === 0 || ref === (void 0) || ref === null) {
          return '-';
        }
        if (!event.old_event && $scope.isFreeTrials) {
          return event.prospect_vacancies_count;
        } else if (!event.old_event && !$scope.isFreeTrials) {
          return event.vacancies_count;
        } else {
          return '-';
        }
      };
      return $scope.fontColor = function(color) {
        return ContrastColor.get(color);
      };
    }]
  };
});
